export default __webpack_public_path__ + "static/media/video.85b18bfd.mp4";